import type { ReactNode } from 'react';
import styles from './auth.module.css';

interface BrandSide {
  title: string;
  body: string;
}

interface Props {
  title: string;
  subtitle?: string;
  brandSide: BrandSide;
  children: ReactNode;
}

function BrandLogo() {
  return (
    <svg viewBox="0 0 100 100" width="44" height="44" aria-hidden="true">
      <circle cx="50" cy="50" r="46" fill="#FFCD2E" stroke="#0E0E10" strokeWidth="3.5" />
      <path
        d="M30 42c2-2 6-2 8 0M62 42c2-2 6-2 8 0"
        stroke="#0E0E10"
        strokeWidth="4.5"
        fill="none"
        strokeLinecap="round"
      />
      <path
        d="M36 60c4 5 10 7 14 7s10-2 14-7"
        stroke="#0E0E10"
        strokeWidth="4.5"
        fill="none"
        strokeLinecap="round"
      />
    </svg>
  );
}

export function AuthShell({ title, subtitle, brandSide, children }: Props) {
  return (
    <div className={styles.shell}>
      <aside className={styles.side}>
        <div className={styles.brand}>
          <BrandLogo />
          <span>FocusMode</span>
        </div>
        <div className={styles.quote}>
          <h2>{brandSide.title}</h2>
          <p>{brandSide.body}</p>
          <div className={styles.stats}>
            <div>
              <strong className="num">14</strong>
              <small>מודולים</small>
            </div>
            <div>
              <strong className="num">8</strong>
              <small>אינטגרציות</small>
            </div>
            <div>
              <strong>RTL</strong>
              <small>עברית מקורית</small>
            </div>
          </div>
        </div>
        <small className={styles.footSmall}>© 2026 FocusMode · focusmode.info</small>
      </aside>
      <main className={styles.main}>
        <div className={styles.card}>
          <h1 className={styles.eyebrow}>{title}</h1>
          {subtitle ? <p className={styles.sub}>{subtitle}</p> : null}
          {children}
        </div>
      </main>
    </div>
  );
}
